import { Component, OnInit } from '@angular/core';
import { UserModel } from 'src/app/models/user.model';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

import { AuthService } from 'src/app/services/auth.service';
import { PaymentsService } from 'src/app/services/payments.service';
import { NgForm } from '@angular/forms';
import { UserHelper } from '../../helpers/user';
import { CommonHelper } from 'src/app/helpers/common';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  userLogin$: Observable<UserModel>;
  public user: UserModel = new UserModel();

  public payments;

  constructor(
    private auth: AuthService,
    private paymentsService: PaymentsService,
    private userHelper: UserHelper,
    private commonHelper: CommonHelper,
    private router: Router) {
    this.user = this.userHelper.getUser();
    this.userLogin$ = this.auth.getLoginAuthenticate$();
    this.userLogin$.subscribe(userModel => this.user = userModel);

    if (this.user.id !== 0 && this.user.id != null) {
      this.auth.getProfile().subscribe(data => {
        // obtener los pagos hechos por el usuario, la consulta se hace mediante el token enviado
        this.getPayments();
      });
    } else {
      this.router.navigateByUrl('/');
    }
  }

  ngOnInit() { }

  getPayments() {
    console.log("token", localStorage.getItem('token'));
    this.paymentsService.getPaymentsByToken().subscribe(payments => {
      this.payments = payments['response'].data;
    }, (err) => {
      console.log('Get payments error: ', err);
    });
  }

  updateProfile(form: NgForm) {
    console.log(form);

    if (form.invalid) { return; }

    Swal.fire({
      allowOutsideClick: false,
      type: 'info',
      text: this.commonHelper.getTranslation('errors.pleaseWait')
    });
    Swal.showLoading();

    this.auth.update(this.user).subscribe(resp => {
      Swal.fire({
        type: 'success',
        title: '',
        text: 'Cambios guardados',
        confirmButtonText: 'Cerrar'
      });
    }, (err) => {
      console.log(err);
      Swal.fire({
        type: 'error',
        title: '',
        text: this.commonHelper.getTranslation('errors.serverError')
      });
      console.log("Error al actualizar usuario:", err);
    });
  }

  logout() {
    this.auth.logout();
    this.router.navigateByUrl('/home')
  }

  scrolling(position) {

    var elmnt = document.getElementById(position);
    elmnt.scrollIntoView({ behavior: 'smooth' });
  }
}
